module.exports = __webpack_public_path__ + "static/img/item_j_tropical.b58a96d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item_j_tropical.png
// module id = iVnq
// module chunks = 1